// Build-time opt-in. Ordinary website bundles never consult the native bridge.
export const isMobileBuild = process.env.REACT_APP_RUNTIME === 'mobile';
export function getRuntimeAdapter() {
  if (!isMobileBuild || typeof window === 'undefined') return null;
  return window.KickVizMobile || window.parent?.KickVizMobile || null;
}

// ── Which modifier does the USER's keyboard use? ───────────────────────────
// Every chord in the app already accepts ⌘ OR Ctrl (mod = metaKey || ctrlKey),
// but the hints are written "Ctrl+Z" — on a Mac that teaches the wrong fingers
// for a verb that works either way. Rather than fork ~70 strings, the surfaces
// that DISPLAY chords rewrite them once, at render time.
const nav = (typeof navigator !== 'undefined') ? navigator : {};

export const IS_MAC = /Mac|iPhone|iPad|iPod/i.test(`${nav.platform || ''} ${nav.userAgent || ''}`);

/**
 * Is the primary input a finger? ONE probe, shared: the camera picks its starting
 * mode with it, and the mark dial sizes its hit areas with it. Anything that
 * grows a target for a thumb asks this rather than reading matchMedia itself, so
 * the app cannot end up with two opinions about what kind of device it is on.
 */
export function coarsePointer() {
  try {
    return typeof window !== 'undefined' && !!window.matchMedia
      && window.matchMedia('(pointer: coarse)').matches;
  } catch {
    // jsdom, or a browser without matchMedia: assume a mouse.
    return false;
  }
}

/**
 * Rewrite Ctrl-flavoured chord text to the platform's own modifier:
 *   'Ctrl+Z undoes' → '⌘+Z undoes'   (Mac only)
 *   'press Ctrl'    → 'press ⌘'
 * Non-Mac platforms and non-strings pass through untouched.
 */
export function macChords(text) {
  if (!IS_MAC || typeof text !== 'string') return text;
  return text
    .replace(/Ctrl\+/g, '⌘+')
    .replace(/Control\+/g, '⌘+')
    .replace(/\bCtrl\b/g, '⌘');
}
